import { Component, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DynamicComponentDirective } from '../../../directives/dynamic-component.directive';
import * as Models from '../../../models/models-index';
import { ElementComponent } from '../../../models/models-index';
import { PanelElementFormattingService } from '../panel-element-formatting.service';
import { PanelElementResolverService } from '../panel-element-resolver.service';

@Component({
  selector: 'ghost-panel',
  templateUrl: './ghost-panel.component.html',
  styleUrls: ['./ghost-panel.component.scss']
})
export class GhostPanelComponent implements OnInit, Models.PanelComponent {

  @ViewChild(DynamicComponentDirective, { static: true }) dynamicComponent!: DynamicComponentDirective;
  @Input() panelConfig: Models.Panel;
  private componentInstances: Models.ElementComponent[] = [];

  private _dataSets: Models.DataSet[] = [];
  @Input()
  set dataSets(value: Models.DataSet[]) {
    this._dataSets = value;
    if(this._dataSets?.length > 0)
    {
      this.assignDataToElement();
      return;
    }

    this.componentInstances.forEach(instance => {
      instance.dataSets = null;
    });
  }
  get dataSets(): Models.DataSet[] {
    return this._dataSets;
  }

  @Input() rowPanelId: string;
  @Input() viewContext?: Models.ViewContext;

  panelTitle;

  constructor(private resolverService: PanelElementResolverService,
    private panelFormattingService: PanelElementFormattingService,
    private renderer2: Renderer2) { }

  ngOnInit(): void {
    this.generateElements(this.panelConfig);
  }

  generateElements(panelConfig) {
    const config = panelConfig;// || this.getDefaultPanelConfig();
    // const datasets = dataSets;// || this.getDefaultDataSets();
    this.panelTitle = config?.title;

    const viewContainerRef = this.dynamicComponent.viewContainerRef;
    viewContainerRef.clear();
    this.componentInstances = [];

    config.elements.forEach(element => {
      const componentRef = this.resolverService.resolveElementComponent(viewContainerRef, element.type);
      componentRef.instance.settings = element.settings;
      componentRef.instance.viewContext = this.viewContext;
      this.componentInstances.push(componentRef.instance);

      this.renderer2.addClass(componentRef.location.nativeElement, 'ghost-panel-element');
      this.renderer2.setAttribute(componentRef.location.nativeElement, 'style', this.panelFormattingService.getPanelStyles(element.settings))
    })
  }

  private assignDataToElement(): void {
    this.componentInstances.forEach(instance => {
      const dataSetNames = instance.settings.dataSets ?? [instance.settings.dataSet];
      const dataSets = this.dataSets.filter(ds => dataSetNames.includes(ds.name));
      instance.dataSets = dataSets;
    });
  }
}
